import React from "react";
import {connect} from "react-redux";
import {bindActionCreators, compose} from "redux";
import {styles} from "./../../styles/documents";
import {withStyles} from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from "@material-ui/core/Button";
import {
    setContestDialogOpenZajavls,
    setZajavlEditUuidZajavls,
    setContestEditFormZajavls,
} from '@componentDP/js_react/redux/actions/zajavls';
import {configEduLevelsTranslateMap} from "./../../config/edu_levels";
import {configEduFormsTranslateMap} from "./../../config/edu_forms";
import {configSourcesTranslateMap} from "./../../config/sources";
import {configRequirementsTranslateMap} from './../../config/requirements';
import IconButton from "@material-ui/core/IconButton";
import Close from '@material-ui/icons/Close';
import Typography from "@material-ui/core/Typography";
import {TARGET_SOURCE_ID} from '../../constants';
import ContestExams from './zajavls/ContestExams';
import {withTranslation} from "react-i18next";

class Contests extends React.Component {
    constructor(props) {
        super(props);
        this.addContest = this.addContest.bind(this);
    }
    addContest() {
        const {zajavl} = this.props;
        const {setContestDialogOpenZajavls, setZajavlEditUuidZajavls, setContestEditFormZajavls} = this.props;
        setZajavlEditUuidZajavls(zajavl.uuid);
        setContestEditFormZajavls({});
        setContestDialogOpenZajavls(true);
    }
    render() {
        const {classes, zajavl, handleOpenConfirmDialog, t} = this.props;
        const {addContest} = this;
        return(
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        {t('competitions')}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TableContainer>
                        <Table className={classes.tableBorder} size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center"><Typography variant="body1">№</Typography></TableCell>
                                    <TableCell><Typography variant="body1">{t('edu_level')}</Typography></TableCell>
                                    <TableCell><Typography variant="body1">{t('competition_group_id')}</Typography></TableCell>
                                    <TableCell><Typography variant="body1">{t('form')}</Typography></TableCell>
                                    <TableCell><Typography variant="body1">{t('source_id')}</Typography></TableCell>
                                    <TableCell><Typography variant="body1">{t('other_information')}</Typography></TableCell>
                                    <TableCell><Typography variant="body1">{t('list_of_entrance_tests')}</Typography></TableCell>
                                    <TableCell />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {zajavl.contests.map((contest, numContest) => {
                                    return (
                                        <TableRow key={contest.uuid}>
                                            <TableCell align="center">
                                                <Typography variant="body1">
                                                    {numContest + 1}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="body1">
                                                    {configEduLevelsTranslateMap[contest.edu_level_id]
                                                        ? t(configEduLevelsTranslateMap[contest.edu_level_id])
                                                        : '-'}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="body1">
                                                    {contest.competition_group_name}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="body1">
                                                    {configEduFormsTranslateMap[contest.form]
                                                        ? t(configEduFormsTranslateMap[contest.form])
                                                        : null}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="body1">
                                                    {configSourcesTranslateMap[contest.source_id]
                                                        ? t(configSourcesTranslateMap[contest.source_id])
                                                        : t('not_selected')}
                                                </Typography>
                                                <Typography variant="body1">
                                                    {configSourcesTranslateMap[contest.source_id]
                                                    && Number(contest.source_id) === TARGET_SOURCE_ID
                                                        ? `${t('target_customer')}: ${contest.target_customer}`
                                                        : null}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography variant="body1">
                                                    {t('requirement_id')}:<br/>
                                                    {t(configRequirementsTranslateMap[contest.requirement_id])}
                                                </Typography>
                                                <Typography variant="body1">
                                                    {t('for_foreign_citizens')}: {contest.for_foreign_citizens ? t('yes') : t('no')}
                                                </Typography>
                                                <Typography variant="body1">
                                                    {t('is_based_prof_education')}: {contest.is_based_prof_education ? t('yes') : t('no')}
                                                </Typography>
                                                <Typography variant="body1">
                                                    {t('want_use_privilege_into_list')}: {contest.is_want_use_privilege ? t('yes') : t('no')}
                                                </Typography>

                                            </TableCell>
                                            <TableCell>
                                                <ContestExams constestExams={contest.exams} />
                                            </TableCell>
                                            <TableCell align="right">
                                                <IconButton
                                                    aria-label="delete"
                                                    color="secondary"
                                                    size="small"
                                                    onClick={() => handleOpenConfirmDialog(contest.uuid, 'remove-contest')}
                                                    disabled={zajavl.is_save_without_send_allowed === false && zajavl.is_save_and_send_allowed === false}
                                                    title={t('delete')}
                                                >
                                                    <Close />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid item xs={12}>
                    {typeof zajavl.id === 'undefined' || zajavl.is_save_without_send_allowed !== false || zajavl.is_save_and_send_allowed !== false
                        ? <Button
                            variant="outlined"
                            size="small"
                            onClick={addContest}
                            disabled={zajavl.is_save_without_send_allowed === false && zajavl.is_save_and_send_allowed === false}
                        >
                            {t('add_competition')}
                        </Button>
                        : null}
                </Grid>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setContestDialogOpenZajavls,
        setZajavlEditUuidZajavls,
        setContestEditFormZajavls,
    }, dispatch);
}

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(withTranslation()(Contests));
